import type { LanguageCode } from "config/languages";
import { getSocialLink } from "utils/socialUtils";

export const dynamicLinksPlaceholders = {
  "{{funnel}}": "webappNewClaim",
  "{{airlines}}": "airlines",
  "{{airports}}": "airports",
  "{{airlineStrikeCompensation}}": "airlineStrikeCompensation",
};

// TODO: remove this when we have a proper way to get the social links
export const socialLinksPlaceholders = {
  "{{facebook}}": (language: LanguageCode) => getSocialLink(language, "facebook"),
  "{{instagram}}": (language: LanguageCode) => getSocialLink(language, "instagram"),
  "{{twitter}}": (language: LanguageCode) => getSocialLink(language, "twitter"),
  "{{linkedin}}": (language: LanguageCode) => getSocialLink(language, "linkedin"),
};

export const socialLinksPlaceholdersKeys = Object.keys(socialLinksPlaceholders);
export const dynamicLinksPlaceholdersKeys = Object.keys(dynamicLinksPlaceholders);
